<template>
  <table class="p-datatable p-datatable-sm p-datatable-hoverable-rows positions-table">
    <thead class="p-datatable-thead">
    <tr class="table-opened-info__header-row">
      <th style="width: 16%">{{ manager.name }}</th>
      <th style="width: 10%">{{ $t('Count') }}</th>
      <th style="width: 12%">{{ $t('purchasePriceShortLabel') }}</th>
      <template v-if="!isWarrantyPanel">
        <th style="width: 12%">{{ $t('sellingPriceShortLabel') }}</th>
        <th style="width: 12%">{{ $t('Tax') }}</th>
        <th style="width: 10%">{{ $t('Discount') }}</th>
        <th style="width: 10%">{{ $t('markupPercentLabel') }}</th>
        <th style="width: 10%">{{ $t('marginLabel') }}</th>
        <th style="width: 16%">{{ $t('grossProfitLabel') }}</th>
      </template>
    </tr>
    </thead>

    <tbody class="p-datatable-tbody">
    <template v-if="manager.services?.count">
      <tr>
        <td>
          <div class="p-d-flex p-ai-center">
            <a href="#" @click.prevent="toggleShowItems(1)" class="p-mr-2">
              <i style="font-size: 0.9em" class="p-mr-1 pi" :class="showServices ? 'pi-minus': 'pi-plus'"></i>
              <span>{{ $t('Services') }}</span>
            </a>
          </div>
        </td>
        <td>{{ manager.services.count }}</td>
        <td>{{ formatCurrency(manager.services?.purchase_sum) }}</td>
        <template v-if="!isWarrantyPanel">
          <td>{{ formatCurrency(manager.services?.sell_price) }}</td>
          <td>{{ formatCurrency(manager.services?.tax_sum) }}</td>
          <td>{{ formatCurrency(manager.services?.discount_sum) }}</td>
          <td>
            <template v-if="markupsByKey.has(markupKey(manager.services))">
              <span>{{ markupsByKey.get(markupKey(manager.services)) }}</span>
            </template>
            <i v-else class="ti-minus"/>
          </td>
          <td>
            <template v-if="marginsByKey.has(marginKey(manager.services))">
              <span>{{ marginsByKey.get(marginKey(manager.services)) }}</span>
            </template>
            <i v-else class="ti-minus"/>
          </td>
          <td>{{ formatCurrency(calculateProfit(manager.services)) }}</td>
        </template>
      </tr>

      <tr v-show="showServices" class="table-opened-info">
        <td colspan="20" style="padding:0!important;">
          <ManagerSalesPositionsTable
              :isWarrantyPanel="isWarrantyPanel"
              :managerId="manager?.id"
              :type="1"
              :isShown="showServices"
              :isSpoilerTable="true"
              :fromTimestamp="fromTimestamp"
              :toTimestamp="toTimestamp"
              :searchData="searchData"
          />
        </td>
      </tr>
    </template>

    <template v-if="manager.requests?.count">
      <tr>
        <td>
          <div class="p-d-flex p-ai-center">
            <a href="#" @click.prevent="toggleShowItems(2)" class="p-mr-2">
              <i style="font-size: 0.9em" class="p-mr-1 pi" :class="showRequests ? 'pi-minus': 'pi-plus'"></i>
              <span>{{ $t('specialOrderPositionsLabel') }}</span>
            </a>
          </div>
        </td>
        <td>{{ manager.requests.count }}</td>
        <td>{{ formatCurrency(manager.requests?.purchase_sum) }}</td>
        <template v-if="!isWarrantyPanel">
          <td>{{ formatCurrency(manager.requests?.sell_price) }}</td>
          <td>{{ formatCurrency(manager.requests?.tax_sum) }}</td>
          <td>{{ formatCurrency(manager.requests?.discount_sum) }}</td>
          <td>
            <template v-if="markupsByKey.has(markupKey(manager.requests))">
              <span>{{ markupsByKey.get(markupKey(manager.requests)) }}</span>
            </template>
            <i v-else class="ti-minus"/>
          </td>
          <td>
            <template v-if="marginsByKey.has(marginKey(manager.requests))">
              <span>{{ marginsByKey.get(marginKey(manager.requests)) }}</span>
            </template>
            <i v-else class="ti-minus"/>
          </td>
          <td>{{ formatCurrency(calculateProfit(manager.requests)) }}</td>
        </template>
      </tr>

      <tr v-show="showRequests" class="table-opened-info">
        <td colspan="20" style="padding:0!important;">
          <ManagerSalesPositionsTable
              :isWarrantyPanel="isWarrantyPanel"
              :managerId="manager?.id"
              :type="2"
              :isShown="showRequests"
              :isSpoilerTable="true"
              :fromTimestamp="fromTimestamp"
              :toTimestamp="toTimestamp"
              :searchData="searchData"
          />
        </td>
      </tr>
    </template>

    <template v-if="manager.warehouse_positions?.count">
      <tr>
        <td>
          <div class="p-d-flex p-ai-center">
            <a href="#" @click.prevent="toggleShowItems(3)" class="p-mr-2">
              <i style="font-size: 0.9em" class="p-mr-1 pi" :class="showWarehouseItems ? 'pi-minus': 'pi-plus'"></i>
              <span>{{ $t('Stock items') }}</span>
            </a>
          </div>
        </td>
        <td>{{ manager.warehouse_positions.count }}</td>
        <td>{{ formatCurrency(manager.warehouse_positions?.purchase_sum) }}</td>
        <template v-if="!isWarrantyPanel">
          <td>{{ formatCurrency(manager.warehouse_positions?.sell_price) }}</td>
          <td>{{ formatCurrency(manager.warehouse_positions?.tax_sum) }}</td>
          <td>{{ formatCurrency(manager.warehouse_positions?.discount_sum) }}</td>
          <td>
            <template v-if="markupsByKey.has(markupKey(manager.warehouse_positions))">
              <span>{{ markupsByKey.get(markupKey(manager.warehouse_positions)) }}</span>
            </template>
            <i v-else class="ti-minus"/>
          </td>
          <td>
            <template v-if="marginsByKey.has(marginKey(manager.warehouse_positions))">
              <span>{{ marginsByKey.get(marginKey(manager.warehouse_positions)) }}</span>
            </template>
            <i v-else class="ti-minus"/>
          </td>
          <td>{{ formatCurrency(calculateProfit(manager.warehouse_positions)) }}</td>
        </template>
      </tr>

      <tr v-show="showWarehouseItems" class="table-opened-info">
        <td colspan="20" style="padding:0!important;">
          <ManagerSalesPositionsTable
              :isWarrantyPanel="isWarrantyPanel"
              :managerId="manager?.id"
              :type="3"
              :isShown="showWarehouseItems"
              :isSpoilerTable="true"
              :fromTimestamp="fromTimestamp"
              :toTimestamp="toTimestamp"
              :searchData="searchData"
          />
        </td>
      </tr>
    </template>

    <template v-if="manager.free_positions?.count">
      <tr>
        <td>
          <div class="p-d-flex p-ai-center">
            <a href="#" @click.prevent="toggleShowItems(4)" class="p-mr-2">
              <i style="font-size: 0.9em" class="p-mr-1 pi" :class="showFreeItems ? 'pi-minus': 'pi-plus'"></i>
              <span>{{ $t('freePositionsLabel') }}</span>
            </a>
          </div>
        </td>
        <td>{{ manager.free_positions.count }}</td>
        <td>{{ formatCurrency(manager.free_positions?.purchase_sum) }}</td>
        <template v-if="!isWarrantyPanel">
          <td>{{ formatCurrency(manager.free_positions?.sell_price) }}</td>
          <td>{{ formatCurrency(manager.free_positions?.tax_sum) }}</td>
          <td>{{ formatCurrency(manager.free_positions?.discount_sum) }}</td>
          <td>
            <template v-if="markupsByKey.has(markupKey(manager.free_positions))">
              <span>{{ markupsByKey.get(markupKey(manager.free_positions)) }}</span>
            </template>
            <i v-else class="ti-minus"/>
          </td>
          <td>
            <template v-if="marginsByKey.has(marginKey(manager.free_positions))">
              <span>{{ marginsByKey.get(marginKey(manager.free_positions)) }}</span>
            </template>
            <i v-else class="ti-minus"/>
          </td>
          <td>{{ formatCurrency(calculateProfit(manager.free_positions)) }}</td>
        </template>
      </tr>

      <tr v-show="showFreeItems" class="table-opened-info">
        <td colspan="20" style="padding:0!important;">
          <ManagerSalesPositionsTable
              :isWarrantyPanel="isWarrantyPanel"
              :managerId="manager?.id"
              :type="4"
              :isShown="showFreeItems"
              :isSpoilerTable="true"
              :fromTimestamp="fromTimestamp"
              :toTimestamp="toTimestamp"
              :searchData="searchData"
          />
        </td>
      </tr>
    </template>

    <tr class="table-opened-info__row--total">
      <td class="no-bottom-border">{{ $t('Total') }}</td>
      <td class="no-bottom-border">{{ calculateCount(manager) }}</td>
      <td class="no-bottom-border">{{ formatCurrency(calculatePurchaseSum(manager)) }}</td>
      <template v-if="!isWarrantyPanel">
        <td class="no-bottom-border">{{ formatCurrency(calculateSellSum(manager)) }}</td>
        <td class="no-bottom-border">{{ formatCurrency(calculateTaxSum(manager)) }}</td>
        <td class="no-bottom-border">{{ formatCurrency(calculateTotalDiscountSum(manager)) }}</td>
        <td class="no-bottom-border">
          <i class="ti-minus"/>
        </td>
        <td class="no-bottom-border">
          <i class="ti-minus"/>
        </td>
        <td class="no-bottom-border">{{ formatCurrency(calculateTotalProfit(manager)) }}</td>
      </template>
    </tr>
    </tbody>
  </table>
</template>

<script>
import formatMixins from "@/mixins/formatMixins";
import ManagerSalesPositionsTable from "@/pages/overview/components/ManagerSalesPositionsTable";
import showErrorsMixins from "@/mixins/showErrorsMixins";

export default {
  mixins: [formatMixins, showErrorsMixins],
  components: { ManagerSalesPositionsTable },
  name: 'ManagerSalesPanelTable',
  props: {
    isWarrantyPanel: {
      type: Boolean,
      default: false
    },
    manager: {
      type: Object,
      default: null
    },
    fromTimestamp: {
      type: Number,
      default: null
    },
    toTimestamp: {
      type: Number,
      default: null
    },
    searchData: {
      type: String,
      default: ''
    },
  },
  watch: {
    searchData() {
      this.closeAllOpenedTables()
    },
  },
  data: () => ({
    showServices: false,
    showRequests: false,
    showWarehouseItems: false,
    showFreeItems: false,
    // servicePositions: [],
    // requestsPositions: [],
    // warehousePositions: [],
    // freePositions: [],
    isCollapsed: false,
  }),
  methods: {
    closeAllOpenedTables() {
      this.showServices = false
      this.showRequests = false
      this.showWarehouseItems = false
      this.showFreeItems = false
    },
    toggleShowItems(type) {
      if (type === 1) {
        this.showServices = !this.showServices
      } else if (type === 2) {
        this.showRequests = !this.showRequests
      } else if (type === 3) {
        this.showWarehouseItems = !this.showWarehouseItems
      } else if (type === 4) {
        this.showFreeItems = !this.showFreeItems
      }
    },

    markupKey(p) {
      return p?.id ?? p?.type ?? p?.name ?? JSON.stringify([p?.count, p?.purchase_sum, p?.sell_price])
    },

    marginKey(p) {
      return p?.id ?? p?.type ?? p?.name ?? JSON.stringify([p?.count, p?.purchase_sum, p?.sell_price])
    },

    // calculateManagerMarkup(row) {
    //   if (!row) return
    //
    //   const purchase = +row.purchase_sum || 0
    //   const sell = +row.sell_price || 0
    //
    //   if (purchase <= 0) return
    //
    //   const markup = ((sell - purchase) / purchase) * 100
    //   if (!isFinite(markup)) return
    //
    //   const normalized = Math.abs(markup) < 1e-10 ? 0 : markup
    //   return this.formatDecimal(normalized) + '%'
    // },

    money(value) {
      const number = Number(String(value ?? 0).replace(',', '.'))

      if (!Number.isFinite(number)) return 0

      const rounded =
          Math.sign(number) *
          Math.round((Math.abs(number) + Number.EPSILON) * 100) /
          100

      return Math.abs(rounded) < 0.005 ? 0 : rounded
    },

    // calculateManagerMarkup(row) {
    //   if (!row) return
    //
    //   const purchase = +row.purchase_sum || 0
    //   const sell = +row.sell_price || 0
    //
    //   if (purchase <= 0) return
    //
    //   const markup = ((sell - purchase) / purchase) * 100
    //   if (!isFinite(markup)) return
    //
    //   const normalized = Math.abs(markup) < 1e-10 ? 0 : markup
    //
    //   if (normalized > 1000) {
    //     return '>1000,00%'
    //   }
    //
    //   if (normalized < -1000) {
    //     return '<-1000,00%'
    //   }
    //
    //   return this.formatDecimal(normalized) + '%'
    // },

    // calculateManagerMargin(row) {
    //   if (!row) return
    //
    //   const sell = +row.sell_price || 0
    //   if (!sell) return
    //
    //   const profit = sell - (+row.purchase_sum || 0)
    //   const margin = (profit / sell) * 100
    //   if (!isFinite(margin)) return
    //
    //   const normalized = Math.abs(margin) < 1e-10 ? 0 : margin
    //   return this.formatDecimal(normalized) + '%'
    // },

    calculateManagerMarkup(row) {
      if (!row) return

      const purchase = this.money(row.purchase_sum)
      const sell = this.money(row.sell_price)

      if (purchase <= 0) return

      const markup = ((sell - purchase) / purchase) * 100

      if (!Number.isFinite(markup)) return

      if (markup > 1000) {
        return '>1000,00%'
      }

      if (markup < -1000) {
        return '<-1000,00%'
      }

      const normalized = Math.abs(markup) < 1e-10 ? 0 : markup

      return this.formatDecimal(normalized) + '%'
    },

    calculateManagerMargin(row) {
      if (!row) return

      const sell = this.money(row.sell_price)
      const purchase = this.money(row.purchase_sum)

      if (!sell) return

      const profit = this.money(sell - purchase)
      const margin = (profit / sell) * 100

      if (!Number.isFinite(margin)) return

      const normalized = Math.abs(margin) < 1e-10 ? 0 : margin

      return this.formatDecimal(normalized) + '%'
    },

    calculateProfit(position) {
      if (!position) return 0

      const sell = this.money(position.sell_price)
      const purchase = this.money(position.purchase_sum)

      return this.money(sell - purchase)
    },

    calculateCount(manager) {
      if (!manager) return 0
      const servicesCount = manager.services?.count ?? 0
      const requestsCount = manager.requests?.count ?? 0
      const warehousePositionsCount = manager.warehouse_positions?.count ?? 0
      const freePositionsCount = manager.free_positions?.count ?? 0
      return +servicesCount + +requestsCount + +warehousePositionsCount + +freePositionsCount
    },

    calculatePurchaseSum(manager) {
      if (!manager) return 0
      const servicesPurchaseSum = manager.services?.purchase_sum ?? 0
      const requestsPurchaseSum = manager.requests?.purchase_sum ?? 0
      const warehousePositionsPurchaseSum = manager.warehouse_positions?.purchase_sum ?? 0
      const freePositionsPurchaseSum = manager.free_positions?.purchase_sum ?? 0
      return +servicesPurchaseSum + +requestsPurchaseSum + +warehousePositionsPurchaseSum + +freePositionsPurchaseSum
    },

    calculateSellSum(manager) {
      if (!manager) return 0
      const servicesSellSum = manager.services?.sell_price ?? 0
      const requestsSellSum = manager.requests?.sell_price ?? 0
      const warehousePositionsSellSum = manager.warehouse_positions?.sell_price ?? 0
      const freePositionsSellSum = manager.free_positions?.sell_price ?? 0
      return +servicesSellSum + +requestsSellSum + +warehousePositionsSellSum + +freePositionsSellSum
    },

    calculateTaxSum(manager) {
      if (!manager) return 0
      const servicesTaxSum = manager.services?.tax_sum ?? 0
      const requestsTaxSum = manager.requests?.tax_sum ?? 0
      const warehousePositionsTaxSum = manager.warehouse_positions?.tax_sum ?? 0
      const freePositionsTaxSum = manager.free_positions?.tax_sum ?? 0
      return +servicesTaxSum + +requestsTaxSum + +warehousePositionsTaxSum + +freePositionsTaxSum
    },

    calculateTotalDiscountSum(manager) {
      if (!manager) return 0
      const servicesDiscountSum = manager.services?.discount_sum ?? 0
      const requestsDiscountSum = manager.requests?.discount_sum ?? 0
      const warehousePositionsDiscountSum = manager.warehouse_positions?.discount_sum ?? 0
      const freePositionsDiscountSum = manager.free_positions?.discount_sum ?? 0
      return +servicesDiscountSum + +requestsDiscountSum + +warehousePositionsDiscountSum + +freePositionsDiscountSum
    },

    // calculateProfit(position) {
    //   if (!position) return 0
    //
    //   return Number(position.sell_price || 0) - Number(position.purchase_sum || 0)
    // },

    // calculateTotalProfit(manager) {
    //   if (!manager) return 0
    //
    //   let profit = 0
    //
    //   if (manager.services) {
    //     profit += this.calculateProfit(manager.services)
    //   }
    //
    //   if (manager.requests) {
    //     profit += this.calculateProfit(manager.requests)
    //   }
    //
    //   if (manager.warehouse_positions) {
    //     profit += this.calculateProfit(manager.warehouse_positions)
    //   }
    //
    //   if (manager.free_positions) {
    //     profit += this.calculateProfit(manager.free_positions)
    //   }
    //
    //   return profit
    // },
    calculateTotalProfit(manager) {
      if (!manager) return 0

      const sell = this.calculateSellSum(manager)
      const purchase = this.calculatePurchaseSum(manager)

      return this.money(sell - purchase)
    },
  },
  computed: {
    managerPositions() {
      if (!this.manager) return []

      return [
        this.manager.services,
        this.manager.requests,
        this.manager.warehouse_positions,
        this.manager.free_positions,
      ].filter(Boolean)
    },

    markupsByKey() {
      const map = new Map()

      for (const p of this.managerPositions) {
        const key = this.markupKey(p)
        const val = this.calculateManagerMarkup(p)

        if (val != null && val !== '') {
          map.set(key, val)
        }
      }

      return map
    },

    marginsByKey() {
      const map = new Map()

      for (const p of this.managerPositions) {
        const key = this.marginKey(p)
        const val = this.calculateManagerMargin(p)

        if (val != null && val !== '') {
          map.set(key, val)
        }
      }

      return map
    },
  },
}
</script>

<style scoped lang="scss">
.datatable-wrapper {
  overflow-y: auto;
}
</style>